import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import anim_line from "../../img/winter.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import LoadingButton from "../../Loading/LoadingButton";
import { useSelector } from "react-redux";
import {Activity, HopIcon, Minus, Plus } from 'lucide-react';
import Snackbar from "../../../Snackbar";
import { createCourseByAdminV2 } from "../../../store/actions/CreateCourse/createCourseByAdmin";
import AppMenuCardBlue from "../AppCards/AppMenuCardBlue";
import { getProductByProductId } from "../../../api";
import AreYouSurePopUp from "../../Create/CreateContent/ContentPopUp/AreYouSurePopUp";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import NextStepCardPopUp from "../AppCards/NextStepCardPopUp";
import SettingsToggleCard from "../../UI/SettingsToggleCard";
import AppearanceToggleCard from "../../UI/AppearanceToggleCard";
const StudentLimitProduct = ({setActiveCardOverview,baseUrl,producttype})=>{
  const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("rgba(144, 202, 249,1)");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

 const [loader , setLoader] =useState({status:false});
 const [productName, setProductName] = useState(courseData?.productName?courseData?.productName:"");
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"productName":"");

 let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test Series":
  courseData?.type=="homeTutor"?"Home Tutor Offering":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Digital Product":"Course":"Course";
 const [animate, setAnimate] = useState(false);

 const [totalNo, setTotalNo] = useState(0);
 const [AddCourseToWaitList, setAddCourseToWaitList] = useState(courseData?.enableWaitList?JSON.parse(courseData?.enableWaitList):false);
 useEffect(() => {
  setAddCourseToWaitList(courseData?.enableWaitList?JSON.parse(courseData?.enableWaitList):false)
    setTotalNo(courseData?.maxStudents?JSON.parse(courseData?.maxStudents):0)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);


 useEffect(() => {
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])



  const handleCreateProduct=(editVal,state)=>{
  let sendObject;
  
  if(editVal=="enableWaitList"){
   
    sendObject ={enableWaitList:JSON.stringify(state),
        type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
   }
   if(editVal=="maxStudents"){
      
       sendObject ={maxStudents:JSON.stringify(totalNo),
           type:courseData?.ID?courseData?.type:"course",
         postParent:"0" ,userEmail:user_email?user_email:"",
         currentToken:currentToken?currentToken:"",
         editType:editVal,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
      }
  setLoader({status:true});
  
    const apiData = dispatch(createCourseByAdminV2(sendObject));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
        if(response?.course){
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
    setProductName(response?.course?.productName);
    setProductID(response?.course?.postId);
   setEditType("productName")
   setGoNextPopUp(true);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("rgba(144, 202, 249,1)");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("rgba(144, 202, 249,1)");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("rgba(144, 202, 249,1)");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("rgba(144, 202, 249,1)");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"><div  className="CreateCourseStepsOuter contentPageScroller " style={{background:"#fff",borderRadius:"25px"}}>
<div > 

<div  className=""style={{overflow:"hidden",
transform: animate ? 'scale(1)' : 'scale(.9)',
opacity: animate ? 1 : 0,
transition: 'transform 2s ease, opacity 1s ease',padding:"10px"
,background:"#f9f9f9",borderRadius:"25px",padding:"10px"}}> 


<Activity size={60}   color="rgba(144, 202, 249,1)" /> 

<div class="CreateCourseStepsOuterTitle"> Set Student Enrolment Limit !!!  </div>
{!totalNo?<h4> There Is <span className="coloredTextV1" > No Limit </span>On   Enrolment Of Student To This Course ,
 Any Number Of Students Can Enrol Or Buy This Course .  
</h4>:<h4> This Course Has Student Enrolment Limit Of 
<span  style={{border:"0px solid #f1f1f1",borderRadius:"15px"}} >
   <span style={{background:"#f1f1f1",padding:"5px 10px",borderRadius:"15px",marginLeft:"7px",marginRight:"7px"}}>{totalNo} </span> Students  </span>
Above Which , No Student Can Enrol Or Buy This Course   
</h4>} 
{totalNo?<div class="CreateCourseStepsOuterSubTitle"> This Student Limt Will 
    Decrease In Real Time Once Students Enrol Or Buy This Course.</div>:""}
</div> 
<div align="left" className="itemCourseOuter" style={{overflow:"hidden",
transform: animate ? 'scale(1)' : 'scale(.6)',
opacity: animate ? 1 : 0,
transition: 'transform 2s ease, opacity 1s ease',padding:"10px"
,marginTop:"20px",marginBottom:"0px",background:"rgba(86, 82, 131,.8)"}}> 
                
                <div  className="whatToDoNextItemCardInner" ><div style={{background:"#fff",width:"50px",height:"50px",borderRadius:"50%",
                      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><HopIcon size={32}  color="rgb(86, 82, 131)"/></div> 
             
                <h2 style={{color:"#fff"}}>Next Step</h2> 
                  
                
                </div>
                  <div  style={{display:"flex",justifyContent:"center"}}>
              <AppMenuCardBlue activeCard={""} icon={1} title ="Instructors Info" onClickPopup={
          ()=>{  history.push(`${baseUrl}/instructors`)
          }}  />
           </div> 
           </div> 
          
    </div>  
    <div  className="CreateCourseStepsOuterRight ">
   
    <div style={{marginTop: '0px' ,padding:"9px",}} className="SetValidityCardOuter ">
<div style={{ transform: animate ? 'translateY(0)' : 'translateY(-50px)',
opacity: animate ? 1 : 0,
transition: 'transform 2s ease, opacity 1s ease',}}><div >
  

<div style={{border:"5px solid #f1f1f1",padding:"10px 15px",borderRadius:"15px",minHeight:"210px",marginTop:"40px"}}>
<div
   
   className={`circlekBig activek` }
   style={{background: `${ `conic-gradient(rgba(86, 82, 131,.8) 0% ${parseInt(totalNo)*100/100}%, #ffffff 
                                       ${parseInt(totalNo)*100/100}% 100%)`
                                      }
   `,float:"right",marginTop:"-65px"}} 
 ><div   className={`circlekBigInn `} >
   {parseInt(totalNo)==0?<span style={{fontSize:"18px",fontWeight:"900",color:"rgba(86, 82, 131,.8)"}}>No Limit</span>
   :<span style={{fontSize:"38px",fontWeight:"900",color:"rgba(86, 82, 131,.8)"}}>{(totalNo?totalNo:<span style={{fontSize:"18px",fontWeight:"900",color:"rgba(86, 82, 131,.8)"}}>No Limit</span>)}</span>} 
 </div>
  
 </div>


<h4 style={{background:"#f1f1f1",padding:"10px 5px",borderRadius:"10px",width:"220px"}} > Total Enrolled:
<span style={{background:"#fff",padding:"5px 10px",borderRadius:"5px",marginLeft:"7px",marginRight:"7px"}}> 20 </span> Students</h4>
{parseInt(totalNo)!=0? <h6> Set How Many Students Can Enrol 
<span className="" > Now On</span>
 <span className="coloredTextV1" >  (Set 0 For No Enrolment Limit. )</span> </h6>:""}
 <div  className=" "style={{margin: '0px' ,padding:"9px",}}>

<div style={{gridTemplateColumns:  "15% 70% 15%" ,position:"relative",marginTop: '20px',marginBottom: '40px' }}>
<Minus  onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)>0?parseInt(totalNo)-1:0)
;
}} style={{float:"left",background:"#555555",width:"35px",height:"35px",borderRadius:"50%",marginRight:"10px",
alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}} color="#fff" size={22}/>
<input onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave}  value={parseInt(totalNo)} type="number"
  onChange={(e)=>{setTotalNo(parseInt(e.target.value));}}
  style={{border:"2px dashed #555555 ",borderRadius:"10px",outline:0,float:"left",width:"45%",
    padding:"10px",fontSize:"30px",color:"#555555",fontWeight:"bolder"}}
/><Plus onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)+1)

}}  style={{float:"left",background:"#555555",width:"35px",height:"35px",borderRadius:"50%",marginLeft:"10px",
alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}}  color="#fff" size={22}/>
</div>   

    </div><div  className=" "style={{marginTop: '50px' ,padding:"9px",}}>

    {totalNo&&totalNo!=0? <AppearanceToggleCard  animEffect={500} 
  handleCourseSettings={(state)=>{handleCreateProduct("enableWaitList",state)}} 
   myCardState={AddCourseToWaitList} setMyCardState={setAddCourseToWaitList} 
    progress={45}  icon={100}  title="Add Extra Students To Waitlist"  cursorAlign="" cursorTextVal="Auto Complete Course When Student Finishes All Lessons"/> 
:""}
</div>
</div>



</div> 



</div> 

</div>
   
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateProduct("maxStudents","")}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Update":"Save"} </button>
     
  </div>
  
    <div  className="ikcraft_login-input-card">
   
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
 <div></div>
 {goNextPopUp?<NextStepCardPopUp loadingText="Going Next..."  title="Next Step> Add Instructors Info.   Let's Go Next" type="addAproxContent"
 closePopUp={()=>{setGoNextPopUp(false)}}
 onClickPopup={(type)=>{setTimeout(()=>{
  history.push(`${baseUrl}/instructors`)
 },1000)
  }}/>:""}

  </div></div>
</>}
    </>

}

export default StudentLimitProduct;


